var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSepidar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "300 160 500 750",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #7e7e7e;stroke: #7e7e7e;stroke-linejoin: round;stroke-width: 25 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape 1",
    className: "s0",
    d: "m549 187h1v628.6h-1zm-181 101.1l0.5-0.9 362.6 213.5-0.6 0.9zm-0.7 210.2l0.5-0.8 363 211.5-0.5 0.8zm182.3 317.4l-0.6-0.9 180.3-107.2 0.5 0.9zm180.4-314.6h1.1v206.8h-1.1zm-362.5-214h1.1v210.9h-1.1zm0.9 1.6l-0.5-0.9 180.9-101.6 0.5 0.9zm181.4 315.5l-0.5-0.8 180.6-103.7 0.5 0.9zm-180.5-105.8l-0.5-0.9 181.5-103.5 0.5 0.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSepidar);
export default __webpack_public_path__ + "static/media/sepidar.e5231c3fbf27c8bb32a2d0f40b022d4d.svg";
export { ForwardRef as ReactComponent };